import { FETCH_REPORT_CASE_ASSIGNEES } from '../actions/types'

export default function reportCaseAssigneesReducer(state = null, action) {
    switch (action.type) {
        case FETCH_REPORT_CASE_ASSIGNEES:
            return action.payload
        default:
            return state
    }
}
